// extracted by mini-css-extract-plugin
module.exports =  {"root":"fM5ckyhfVnQJp2rKHLm6"};